import { render, staticRenderFns } from "./user-car-settings.vue?vue&type=template&id=46cc34b5&scoped=true"
import script from "./user-car-settings.vue?vue&type=script&lang=js"
export * from "./user-car-settings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46cc34b5",
  null
  
)

export default component.exports